import React from 'react';
import PropTypes from 'prop-types';
import {PlayerListItem} from './PlayerListItem';
import constants from '../../constants';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';

// this needs to be a class component as using ref to access the dom
class Players extends React.Component {

    setUpGame() {
        window.game = window.gameBuilder.build();
        const back = new Image();
        back.src = constants.back;
        back.onload = function () {
            window.game.Board = back;
            window.game.BeginGame();
        };
    }

    componentDidUpdate() {
        if (this.props.players && this.props.players.length > 0 && window.game == null) {
            this.setUpGame();
        }
    }

    render() {
        let { players } = this.props;

        let pl = <div className="alert alert-info">...loading players for this game.</div>;
        if (players && players.length > 0) {
            pl = players.map(function (p, i) {
                return <PlayerListItem player={p} key={i} />;
            })
         }

        return (<div>
            <p>Play this game, or <Link to="/games">pick a different game here</Link></p>
            <div className="playersContainer" ref={(div) => { this.gameDiv = div }}>

                {pl}
            </div>
        </div>);
    }


    componentDidMount() {

        if (this.props.id) {
            window.game = null;
        }
        else {
            this.setUpGame();
        }


    }
}

export default withRouter(Players);

Players.propTypes = {
    players: PropTypes.array
};


